import { Component } from '@angular/core';
import { GenericTableComponent, GtConfig, GtCustomComponent, GtRow } from '@angular-generic-table/core';
import 'rxjs/add/operator/map';

@Component({
    template: `
    <div style="text-align: center" *ngIf="row.profilename" [innerHTML]="row.profilename | gtHighlight:searchTerms"></div>
    <div  *ngIf="row.profilename"  style="background: rgba(0, 150, 136, 0.1);font-weight: 500;font-size: 13px; line-height: 15px; text-align: center; color: #000000; padding: 0.5rem;" 
    matTooltip="{{row.profilename + '\n' + row.username}}" [innerHTML]="row.username | gtHighlight:searchTerms">
    </div>
    <div style="text-align: center" matTooltip="{{row.time}}">{{row.time}}</div>
    `,
    styles: []
})
export class UserTooltipComponent extends GtCustomComponent<any> {
    constructor() {
        super();
    }
}
// mahima.. add date pipe when issue in iOS syncTime is resolved
// <div style="text-align: center">{{row.time | date: 'short'}}</div>



// WEBPACK FOOTER //
// ./src/app/data-surveys/user-tooltip.component.ts